import React, { useEffect } from "react";
import { useSelector } from 'react-redux';
import { getParameterFromURL } from '../../../utils/scripts';
import Glide from "@glidejs/glide";
import locales from '../../../content.json';
import { RootState } from '../../../store';
import s from "./reviewsSlider.module.scss";
import stars from './img/stars.png';

import img1 from './img/img1.png';
import img2 from './img/img2.png';
import img3 from './img/img3.png';
import img4 from './img/img4.png';
import img5 from './img/img5.png';
import img6 from './img/img6.png';
import img7 from './img/img7.png';
import img8 from './img/img8.png';

import img9Translater from './img/img9Translater.png';
import img10Translater from './img/img10Translater.png';

import img1Dark from './img/img1Dark.png';
import img2Dark from './img/img2Dark.png';
import img3Dark from './img/img3Dark.png';
import img4Dark from './img/img4Dark.png';

type ReviewItem = {
  name: string;
  stars: string;
  title?: string;
  review: string;
  avatar: string;
  boxShadow: string;
  border: string;
};

const sliderOptions = {
  type: "carousel",
  startAt: 0,
  perView: 1,
  peek: { before: 20, after: 20 },
  autoplay: 3000,
  animationDuration: 600,
  animationTimingFunc: 'ease-in-out', 
};

export const ReviewsSlider = () => {
  const darkTheme = getParameterFromURL('darkTheme') === 'true';
  const dogTranslator = useSelector((state: RootState) => state.data.dogTranslator) === 'true';
  const vetOnboarding = useSelector((state: RootState) => state.data.vetOnboarding);
  const nutritionOnboarding = useSelector((state: RootState) => state.data.nutritionOnboarding);

  const data: ReviewItem[] = [
    {name: darkTheme ? '@JakeRider' : '@tenniagirl', stars: stars, title: locales[window.userLang].payment_text_19, review: locales[window.userLang].payment_text_22, avatar: darkTheme ? img1Dark : img1, boxShadow: '3px 5px 0px 0px #BA61FE', border: '1.5px solid #BA61FE' },
    {name: darkTheme ? '@Neo_Storm13*' : '@john_3861', stars: stars, title: locales[window.userLang].payment_text_21, review: locales[window.userLang].payment_text_20, avatar: darkTheme ? img2Dark : img2, boxShadow: '3px 5px 0px 0px #00A36F, 3px 5px 0px 0px #BA61FE', border: '1.5px solid #00A36F' },
    {name: darkTheme ? '@BlazeX_92!' : '@Therealtierra', stars: stars, title: locales[window.userLang].payment_text_23, review: locales[window.userLang].payment_text_24, avatar: darkTheme ? img3Dark : img3, boxShadow: '3px 5px 0px 0px #FF8D00, 3px 5px 0px 0px #BA61FE', border: '1.5px solid #FF8E00' },
    {name: darkTheme ? '@AxelS' : '@1QueenE', stars: stars, title: locales[window.userLang].payment_text_25, review: locales[window.userLang].payment_text_26, avatar: darkTheme ? img4Dark : img4, boxShadow: '3px 5px 0px 0px #BA61FE', border: '1.5px solid #BA61FE' },
  ];

  const vetData: ReviewItem[] = [
    {
      name: "Samantha L.",
      stars: stars,
      review: locales[window.userLang].payment_text_295,
      avatar: img5,
      boxShadow: "3px 5px 0px 0px #BA61FE",
      border: "1.5px solid #BA61FE",
    },
    {
      name: "Michael B.",
      stars: stars,
      review: locales[window.userLang].payment_text_296,
      avatar: img6,
      boxShadow: "3px 5px 0px 0px #00A36F, 3px 5px 0px 0px #BA61FE",
      border: "1.5px solid #00A36F",
    },
    {
      name: "Lauren K.",
      stars: stars,
      review: locales[window.userLang].payment_text_297,
      avatar: img7,
      boxShadow: "3px 5px 0px 0px #FF8D00, 3px 5px 0px 0px #BA61FE",
      border: "1.5px solid #FF8E00",
    },
    {
      name: "Chris D.",
      stars: stars,
      review: locales[window.userLang].payment_text_298,
      avatar: img8,
      boxShadow: "3px 5px 0px 0px #BA61FE",
      border: "1.5px solid #BA61FE",
    },
  ];

  const nutritionData: ReviewItem[] = [
    {
      name: 'Samantha L.',
      stars: stars,
      review: locales[window.userLang].payment_text_343,
      avatar: img5,
      boxShadow: '3px 5px 0px 0px #BA61FE',
      border: '1.5px solid #BA61FE',
    },
    {
      name: 'Michael B.',
      stars: stars,
      review: locales[window.userLang].payment_text_344,
      avatar: img6,
      boxShadow: '3px 5px 0px 0px #00A36F, 3px 5px 0px 0px #BA61FE',
      border: '1.5px solid #00A36F',
    },
    {
      name: 'Lauren K.',
      stars: stars,
      review: locales[window.userLang].payment_text_345,
      avatar: img7,
      boxShadow: '3px 5px 0px 0px #FF8D00, 3px 5px 0px 0px #BA61FE',
      border: '1.5px solid #FF8E00',
    },
  ];

  const dogTranslatorData: ReviewItem[] = [
    {
      name: 'Emily R.',
      stars: stars,
      title: locales[window.userLang].payment_text_19,
      review: locales[window.userLang].payment_text_346,
      avatar: img1,
      boxShadow: '3px 5px 0px 0px #BA61FE',
      border: '1.5px solid #BA61FE',
    },
    {
      name: 'Jake M. ',
      stars: stars,
      title: locales[window.userLang].payment_text_21,
      review: locales[window.userLang].payment_text_347,
      avatar: img9Translater,
      boxShadow: '3px 5px 0px 0px #00A36F, 3px 5px 0px 0px #BA61FE',
      border: '1.5px solid #00A36F',
    },
    {
      name: 'Ashley T.',
      stars: stars,
      title: locales[window.userLang].payment_text_23,
      review: locales[window.userLang].payment_text_348,
      avatar: img10Translater,
      boxShadow: '3px 5px 0px 0px #FF8D00, 3px 5px 0px 0px #BA61FE',
      border: '1.5px solid #FF8E00',
    },
  ];

  const sliderData = dogTranslator ? dogTranslatorData : vetOnboarding ? vetData : nutritionOnboarding ? nutritionData : data;

  useEffect(() => {
    const glide = new Glide(".glide", sliderOptions);
    glide.mount();

    const handleWheel = (event) => {
      if (event.deltaY !== 0) {
        event.preventDefault();
      }
    };

    const handleTouchMove = (event) => {
      if (event.touches.length > 1) return;
      
      // const touch = event.touches[0];
      // if (touch.clientX !== 0) {
      //   event.preventDefault();
      // }
    };

    const sliderElement = document.querySelector('.glide');

    // sliderElement.addEventListener('wheel', handleWheel, { passive: false });
    sliderElement.addEventListener('touchmove', handleTouchMove, { passive: false });

    return () => {
      // sliderElement.removeEventListener('wheel', handleWheel);
      sliderElement.removeEventListener('touchmove', handleTouchMove);
      glide.destroy();
    };
  }, []);

  return (
    <div className={s.reviewsSlider}>
      <h3 className={s.title}>
        {locales[window.userLang].payment_text_169}
      </h3>
      <div className={`glide ${s.slider}`}>
        <div className={s.glide__track} data-glide-el="track">
          <ul className={s.glide__slides}>
            {sliderData.map((item, index) => (
            <li key={index} className={s.glide__slide} style={{boxShadow: item.boxShadow, border: item.border}}>
              <div className={s.header}>
                <img className={s.headerImg} src={item.avatar} alt={item.name} />
                <div className={s.headerTitle}>
                  <h3>
                    {item.name}
                  </h3>
                  <img src={item.stars} alt="5 stars"/>
                </div>
              </div>
              {item.title ? (
                <p className={s.itemtitle}>{item.title}</p>
              ) : null}
              <p className={s.itemReview} dangerouslySetInnerHTML={{ __html: item.review }} />
            </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
